/*
  Sales-Modus (Michel 28.09.2026): Countdown in der Leiste und Abschalten zum Ende, auch auf einer
  schon geladenen Seite. Das Ende rechnet sich aus „TT.MM.JJJJ HH:MM“ in deutscher Zeit (mit Sommer-
  und Winterzeit fuer genau diesen Tag); das ISO-Datum aus Liquid ist nur der Rueckfall.
*/
(function () {
  'use strict';
  function berlinZeit(roh) {
    var m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\s+(\d{1,2}):(\d{2}))?$/.exec((roh || '').trim());
    if (!m) return NaN;
    var utc = Date.UTC(+m[3], +m[2] - 1, +m[1], +(m[4] || 23), +(m[5] || 59));
    try {
      // Versatz Berlin gegen UTC an diesem Zeitpunkt
      var teile = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Berlin', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date(utc));
      var w = {}; teile.forEach(function (t) { w[t.type] = t.value; });
      var alsUtc = Date.UTC(+w.year, +w.month - 1, +w.day, +w.hour, +w.minute);
      return utc - (alsUtc - utc);
    } catch (e) { return NaN; }
  }
  function abschalten() {
    document.documentElement.classList.remove('sale-modus-aktiv');
    document.querySelectorAll('[data-sale-leiste]').forEach(function (l) { l.remove(); });
  }
  var timer = document.querySelector('[data-sale-timer]');
  if (!timer) return;
  var ende = berlinZeit(timer.getAttribute('data-sale-roh'));
  if (isNaN(ende)) ende = Date.parse(timer.getAttribute('data-sale-ende'));
  if (isNaN(ende)) return;
  var feld = function (n) { return timer.querySelector('[data-sale-' + n + ']'); };
  var t = feld('tage'), s = feld('std'), mi = feld('min'), se = feld('sek');
  var zwei = function (x) { return (x < 10 ? '0' : '') + x; };
  function takt() {
    var rest = Math.floor((ende - Date.now()) / 1000);
    if (rest <= 0) { abschalten(); return false; }
    t.textContent = zwei(Math.floor(rest / 86400));
    s.textContent = zwei(Math.floor(rest % 86400 / 3600));
    mi.textContent = zwei(Math.floor(rest % 3600 / 60));
    se.textContent = zwei(rest % 60);
    return true;
  }
  if (takt()) { var uhr = setInterval(function () { if (!takt()) clearInterval(uhr); }, 1000); }
})();
